import { useCart } from '@corratech/pylot-cart-manager'
import { useEffect } from 'react'
import { useRouter } from 'next/router'
import { Cart } from '@pylot-data/pylotschema'
import { useTrackCheckoutStep } from '../hooks'
import { CheckoutStepNameEnum } from '@config/seo/checkoutSteps'
import { CHECKOUT_PAGE_ROUTE } from './useTrackCheckoutPageStep'
import { parseUrlPathName } from '@corratech/pylot-tag-manager/src/utils/parseUrlPathName'
import { useAlfakherContext } from '@components/alfakherContext/AlfakherContext'
import { useUser } from '@corratech/pylot-auth-manager'

const getShippingMethodTitle = ({
    shipping_addresses
}: Cart): string | undefined => {
    if (!Array.isArray(shipping_addresses) || shipping_addresses.length === 0) {
        return
    }
    for (const address of shipping_addresses) {
        if (address?.selected_shipping_method?.carrier_title) {
            return address.selected_shipping_method.carrier_title
        }
    }
}

export const useTrackShippingMethod = (): void => {
    const { isFallback, asPath } = useRouter()
    const trackCheckoutStep = useTrackCheckoutStep()
    const { customer } = useUser()
    const {
        isGuestAddressFormVisible,
        setGuestAddressFormVisible
    } = useAlfakherContext()
    const { data, isValidating } = useCart({
        revalidateOnFocus: false,
        revalidateOnMount: false,
        revalidateOnReconnect: false
    })
    const cart = data?.data?.cart
    const isOptimistic = data?.data?.isOptimistic
    const isShippingMethodSelected = customer
        ? 'true'
        : isGuestAddressFormVisible

    useEffect(() => {
        const methodTitle = cart && getShippingMethodTitle(cart)
        if (parseUrlPathName(asPath) != CHECKOUT_PAGE_ROUTE) {
            setGuestAddressFormVisible(false)
        }

        if (
            isShippingMethodSelected &&
            methodTitle &&
            !isFallback &&
            !isOptimistic &&
            !isValidating &&
            parseUrlPathName(asPath) === CHECKOUT_PAGE_ROUTE
        ) {
            trackCheckoutStep({
                step: CheckoutStepNameEnum.SHIPPING,
                option: methodTitle
            })
        }
    }, [cart, isFallback, isValidating, isOptimistic])
}
